import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Button from 'react-bootstrap-button-loader';
import { Panel } from 'react-bootstrap';
import { Spinner } from '../../../common';
import { convertMillsToDollars } from '../../../../utils/helpers/currency'

class WizardFormStepFour extends Component {
  handleFinish = () => {
    const { dispatch, account, campaignInfo } = this.props;
    dispatch(push(`/advertiser/home/accounts/${account.slug}/campaigns/${campaignInfo.id}`));
  }

  render() {
    const { isLoading, campaignInfo, hasCard, handleAddCard } = this.props;

    return (
      <Panel className={['manage-campaigns', `${!hasCard && !isLoading && 'blocked'}`]}>
        <Panel.Body>
            <div className={`text-center spinkit${isLoading ? ' sk-loading' : ''}`}>
              <Spinner />
              {
                isLoading ?
                <h3>Creating your campaign</h3>
                :
                <h3>Your campaign has been created!</h3>
              }
              <div className="wizard-campaign-details">
                <h4>Your campaign details:</h4>
                <ul className="leaders">
                  <li><span>Campaign Name</span><span>{ campaignInfo.name}</span></li>
                  <li><span>Mo. Budget</span><span> ${convertMillsToDollars(campaignInfo.budget)}</span></li>
                  <li><span>Start Date</span><span>{campaignInfo.start_date}</span></li>
                  <li><span>End Date</span ><span>{campaignInfo.end_date}</span></li>
                  <li><span>Recurring</span><span>{campaignInfo.recurring ? 'YES' : 'NO'}</span></li>
                  <li><span>Status</span><span>{campaignInfo.effective_status}</span></li>
                </ul>
              </div>
          <div className="error">
            <div>
              <p style={{ maxWidth: '600px', margin: 'auto', marginBottom: '20px' }}>
                Your campaign has been created but will not begin until
                you add a credit card to your account!
              </p>
              <Button onClick={handleAddCard}>Add Credit Card</Button>
            </div>
          </div>

              <div className="wizard-form-nav">
                <Button
                  onClick={this.handleFinish}
                >
                  Go To Campaign
                </Button>

              </div>
            </div>
        </Panel.Body>
      </Panel>
    );
  }
}

const mapStateToProps = (state) => {
  const { loader } = state;
  return { isLoading: loader.includes('campaignWizardform') };
};

export default connect(mapStateToProps)(WizardFormStepFour);
